import type { ReactNode } from 'react';
import styles from './ConfirmDialog.module.css';

/**
 * Modal de confirmación reutilizable, sustituye a `window.confirm` para que
 * los diálogos sean coherentes con el resto del admin. Se renderiza con
 * `open=true` y se controla desde el padre (sin estado interno: el padre
 * decide cuándo cerrarlo, normalmente tras `onConfirm`/`onCancel`).
 *
 * `busy=true` desactiva los botones mientras una acción asíncrona corre.
 */
export interface ConfirmDialogProps {
  open: boolean;
  title?: string;
  message: ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
  busy?: boolean;
  hideCancel?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  danger = false,
  busy = false,
  hideCancel = false,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  if (!open) return null;
  return (
    <div className={styles.backdrop} onClick={() => !busy && onCancel()}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        {title && <h3 className={styles.title}>{title}</h3>}
        <div className={styles.message}>{message}</div>
        <div className={styles.actions}>
          {!hideCancel && (
            <button
              type="button"
              className={`${styles.btn} ${styles.btnGhost}`}
              onClick={onCancel}
              disabled={busy}
            >
              {cancelLabel}
            </button>
          )}
          <button
            type="button"
            className={`${styles.btn} ${danger ? styles.btnDanger : styles.btnPrimary}`}
            onClick={onConfirm}
            disabled={busy}
            autoFocus
          >
            {busy ? '…' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
